import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import {DataProvider} from './context/DataContext';
import {AuthProvider} from './context/AuthContext';

// Frontend Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import PrivacyPage from './pages/PrivacyPage';
import LegalPage from './pages/LegalPage';

// Admin Components
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import VehicleManagement from './admin/VehicleManagement';
import AddVehicle from './admin/AddVehicle';
import EditVehicle from './admin/EditVehicle';
import InquiryManagement from './admin/InquiryManagement';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Toaster position="top-right" />
            <Routes>
              {/* Frontend Routes */}
              <Route path="/" element={
                <>
                  <Header />
                  <HomePage />
                  <Footer />
                </>
              } />
              <Route path="/catalogo" element={
                <>
                  <Header />
                  <CatalogPage />
                  <Footer />
                </>
              } />
              <Route path="/vehiculo/:id" element={
                <>
                  <Header />
                  <VehicleDetailPage />
                  <Footer />
                </>
              } />
              <Route path="/servicios" element={
                <>
                  <Header />
                  <ServicesPage />
                  <Footer />
                </>
              } />
              <Route path="/contacto" element={
                <>
                  <Header />
                  <ContactPage />
                  <Footer />
                </>
              } />
              <Route path="/privacidad" element={
                <>
                  <Header />
                  <PrivacyPage />
                  <Footer />
                </>
              } />
              <Route path="/legal" element={
                <>
                  <Header />
                  <LegalPage />
                  <Footer />
                </>
              } />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={
                <AdminLayout>
                  <AdminDashboard />
                </AdminLayout>
              } />
              <Route path="/admin/vehiculos" element={
                <AdminLayout>
                  <VehicleManagement />
                </AdminLayout>
              } />
              <Route path="/admin/vehiculos/nuevo" element={
                <AdminLayout>
                  <AddVehicle />
                </AdminLayout>
              } />
              <Route path="/admin/vehiculos/editar/:id" element={
                <AdminLayout>
                  <EditVehicle />
                </AdminLayout>
              } />
              <Route path="/admin/consultas" element={
                <AdminLayout>
                  <InquiryManagement />
                </AdminLayout>
              } />
            </Routes>
          </div>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;